{
  "earnest-and-commissions": "Depósitos y comisiones",
  "earnest": "Depositos",
  "commission": "Comisión",
  "none": "Ninguno",
  "listing-agent": "Agente de listado",
  "returned-to-buyer": "Devuelto al comprador",
  "seller": "Vendedor",
  "buyers-attorney": "Abogada del comprador",
  "sellers-attorney": "Abogado del vendedor",
  "settlement-agency": "Agencia de liquidación",
  "selling-agent": "Agente de ventas",
  "option-fee": "Tarifa opcional",
  "empty-entries": "No hay entradas. Por favor seleccione una propiedad y agregue una nueva",
  "delete-entry-title": "Eliminar entrada",
  "delete-entry-description": "Esta entrada se eliminará del precio de compra. Esta acción no se puede deshacer."
}
